// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours24: FC<Cancellation24Hours24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path d="M15.25 5.5c-.35 0-.646-.12-.887-.362A1.207 1.207 0 0 1 14 4.25c0-.35.12-.646.363-.888.241-.241.537-.362.887-.362s.646.12.887.362c.242.242.363.538.363.888s-.12.646-.363.888a1.207 1.207 0 0 1-.887.362Zm0 16.5c-.35 0-.646-.12-.887-.363A1.207 1.207 0 0 1 14 20.75c0-.35.12-.646.363-.887.241-.242.537-.363.887-.363s.646.12.887.363c.242.241.363.537.363.887s-.12.646-.363.887a1.207 1.207 0 0 1-.887.363Zm4-13c-.35 0-.646-.12-.887-.363A1.207 1.207 0 0 1 18 7.75c0-.35.12-.646.363-.888.241-.241.537-.362.887-.362s.646.12.887.362c.242.242.363.538.363.888s-.12.646-.363.887A1.207 1.207 0 0 1 19.25 9Zm0 9.5c-.35 0-.646-.12-.887-.363A1.207 1.207 0 0 1 18 17.25c0-.35.12-.646.363-.887.241-.242.537-.363.887-.363s.646.12.887.363c.242.241.363.537.363.887s-.12.646-.363.887a1.207 1.207 0 0 1-.887.363Zm1.5-4.75c-.35 0-.646-.12-.887-.363a1.207 1.207 0 0 1-.363-.887c0-.35.12-.646.363-.887.241-.242.537-.363.887-.363s.646.12.887.363c.242.241.363.537.363.887s-.12.646-.363.887a1.207 1.207 0 0 1-.887.363ZM12 22.5a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12.5c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2.5v2c-2.233 0-4.125.775-5.675 2.325C4.775 8.375 4 10.267 4 12.5c0 2.233.775 4.125 2.325 5.675C7.875 19.725 9.767 20.5 12 20.5v2Zm3.3-5.3L11 12.9V7.5h2v4.6l3.7 3.7-1.4 1.4Z" />
        </svg>
    );
};

export default Cancellation24Hours24;
